<template>
  <div>
    <h1 v-bg-typography="'h1'">Predictions</h1>
    <p v-bg-typography="'body-m'">
      If you want to view your previous heatmaps,
      <router-link to="/predictions/heatmaps">click here</router-link>.
    </p>
  </div>
</template>

<script>
import BgTypography from "@/directives/bg-typography";

export default {
  directives: {
    BgTypography,
  },
  methods: {
    openBrainsight() {
      window.open("https://www.brainsight.app/", "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  margin-bottom: 30px;
  margin-top: 30px;
  max-width: 1000px;
  background-color: white;
  padding: 50px 50px;
  border-radius: 10px;

  .content-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .content-bottom {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px;
  }
}

.bottom-text {
  max-width: 1000px;
  margin: 30px 0;
}
.text {
  max-width: 500px;
  margin: 30px 0;
}
.buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 100px;
}
</style>
